(function (Grindaker, $, window, document) {
  "use strict";
  //## GENERAL Scripts
  var generalScripts = (function () {
    var GLOBS = {
      $body: $("body"),
      $html: $("html"),
      $window: $(window),
      $doc: $(document),
      $layoutSlider: $(".layout-slider"),
      $projectPopupToggle: $("#js-popup-toggle"),
      $projectPopup: $("#project-popup"),
      $closePopup: $("#close-popup"),
      isMobile: Modernizr.mq("(max-width: 767px)"),
      isMobileLandscape: Modernizr.mq("(min-device-width: 360px) and (max-device-width: 820px) and (orientation: landscape)"),
      jsBody: document.getElementById("body"),
      mainNavToggle: document.getElementById("js-nav-toggle"),
      listViewToggle: document.getElementById("list-view-toggle"),
      gridViewToggle: document.getElementById("toggle-grid-view"),
      visibleClass: "is--visible",
      activeClass: "is--active",
      navActiveClass: "nav-active",
      popupSlider: "",
      temasideSlider: "",
    }; 
    //Nav toggle
    var handleNavToggle = function () {
      GLOBS.jsBody.classList.toggle(GLOBS.navActiveClass);
      GLOBS.mainNavToggle.classList.toggle(GLOBS.navActiveClass);
    };
    var handleListcookie = function () {
      setCookie("viewlist", 1, 10);
    };
    var handleListCookieDelete = function () {
      eraseCookie("viewlist");
    };
    function setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    function eraseCookie(name) {
      document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
    $.fn.isInViewport = function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };
    //Binds all handle functions to a new function which is called @init
    var bindEvents = function () {
      //NAV
      GLOBS.mainNavToggle.addEventListener("click", handleNavToggle);
      //Listview
      if (GLOBS.listViewToggle) {
        GLOBS.listViewToggle.addEventListener("click", handleListcookie);
        GLOBS.gridViewToggle.addEventListener("click", handleListCookieDelete);
      }

      //FILTER
      $(".filter-cbox").click(function (e) {
        $("#filter-form").submit();
      });

      //SCALING
      function remFontSize($element) {
        var $baseDiff = 88.8,
          $width = GLOBS.$window.width(),
          $fontSize = $width / $baseDiff;

        $element.css("font-size", $fontSize);
      }
      if (!GLOBS.isMobile && !GLOBS.isMobileLandscape) {
        remFontSize(GLOBS.$html);

        GLOBS.$window.resize(function () {
          remFontSize(GLOBS.$html);
        });
      }
      //Project popup
      function closePopup() {
        $(".popup").fadeOut(300).removeClass("popup--active");
        GLOBS.$body.removeClass("popup-active");

        $(".swiper-slide")
          .find("video")
          .each(function () {
            this.pause();
          });
        if (GLOBS.$body.hasClass("single-projects")) {
          $(".tozoom").remove();
        }
      }
      //BUILD POPUPSLIDER
      jQuery.fn.outer = function () {
        return $($("<div></div>").html(this.clone())).html();
      };
      if (GLOBS.$body.hasClass("single-projects")) {
        $(".for-popup").each(function (e) {
          if ($(this).prop("tagName") == "VIDEO") {
            $("#popup-slides").append('<div class="swiper-slide"><div class="vid single-project-popup__thumb">' + $(this).outer() + "</div></div>");
          } else {
            $("#popup-slides").append('<div class="swiper-slide"><div class="single-project-popup__thumb">' + $(this).outer() + "</div></div>");
          }
        });
      }
      $("video:not(.zoomed-video):not(.popup video.for-popup)").click(function () {
        this.paused ? this.play() : this.pause();
      });
      function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        var results = regex.exec(location.search);

        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
      }
      var hasScroll = getParameterByName("scroll");

      if (hasScroll) {
        console.log("Scroll");
        $("html, body").animate(
          {
            scrollTop: $("#" + hasScroll).offset().top - $("#header").outerHeight(),
          },
          2000
        );
      }
      //TEMASIDE POPUP
      $(".temaside-popup-link").click(function (e) {
        var mySwiper;
        var thisPopup = $(this).parent().next(),
          thisSection = $(this).parent().parent();
        e.preventDefault();
        thisPopup.fadeToggle(300).toggleClass("popup--active");
        GLOBS.$body.toggleClass("popup-active");
        var realindex = 0;
        $(".temaside-slider").owlCarousel({
          items: 1,
          margin: 0,
          loop: false,
          dots: false,
          video: true,
          nav: true,
          navText: ["", ""],
          onTranslated: function (event) {
            realindex = event.item.index;
            if (event.item.index < 1 && thisSection.find(".owl-carousel").hasClass("zoom-active")) {
              thisSection.find(".owl-carousel").parent().parent().removeClass("alt-controls");
            } else {
              if (thisSection.find(".owl-item.active .is-vertical").length > 0) {
                thisSection.find(".owl-carousel").parent().parent().removeClass("alt-controls");
              } else {
                if (thisSection.find(".owl-carousel").hasClass("zoom-active")) {
                  thisSection.find(".owl-carousel").parent().parent().addClass("alt-controls");
                }
              }
            } 
            $(".owl-item video").each(function (index, value) {
              this.pause();
              this.currentTime = 0;
            });
            $(".owl-item.active video").each(function (index, value) {
              this.play();
            });
          },
        });
        thisPopup.find(".popup-link").click(function (e) {
          if (thisPopup.find(".owl-carousel").hasClass("zoom-active")) {
            thisPopup.find(".owl-carousel").removeClass("zoom-active");
            thisPopup.find(".owl-carousel").parent().parent().removeClass("alt-controls");
          } else {
            thisPopup.find(".owl-carousel").addClass("zoom-active");
            if (realindex > 0) {
              thisPopup.find(".owl-carousel").parent().parent().addClass("alt-controls");
            }
          }
          var text = thisPopup.find(".popup-link").text();
          thisPopup.find(".popup-link").text(text == "Forstørr" ? "Forminsk" : "Forstørr");
        });
        $(".zoomed-video").click(function () {
          if (this.paused) {
            console.log("PLAY");
            this.play();
          } else {
            console.log("STOP");
            this.pause();
          }
        });
      });
      function getCharsBefore(str, chr) {
        var index = str.indexOf(chr);
        if (index != -1) {
          return str.substring(0, index + 1);
        }
        return "";
      }
      var words = [];

      $(".project-details__text p").each(function (e) {
        words.push(getCharsBefore($(this).html(), ":"));
        /* $(".project-details__text p:contains('" + wrapperText + "')").html(function (_, html) {
          return html.split(wrapperText).join("<span class='smallcaps'>cow</span>");
        }); */
      });
      /* .+?(?=abc) */
     
      $(".project-details__text p").each(function(e){
       var oldHtml =    $(this).html();
      var newHtml = oldHtml.replace(/(.+?(?=:))/g,"<span class='addline'>$1</span>");
      $(this).html(newHtml);​
      });

      GLOBS.$projectPopupToggle.click(function (e) {
        GLOBS.$projectPopup.fadeToggle(300).toggleClass("popup--active");
        GLOBS.$body.toggleClass("popup-active");
        $("#popup-slides .for-popup").each(function (e) {
          var $cloned = $(this).outer();
          if ($(this).is("img")) {
            if (this.src.indexOf("svg") != -1) {
              var thisSrc = $(this).attr("data-lazy-src");
            } else {
              var thisSrc = $(this).attr("src");
            }
          } else {
            var thisSrc = $(this).attr("src");
          }
          var verticalClass = $(this).hasClass("is-vertical") ? "tozoom zoom-vertical" : "tozoom";
          if ($(this).prop("tagName") == "VIDEO") {
            $(this).prop("autoplay", false);
            $(this).prop("controls", false);
            //thisSrc
            $("video.for-popup").click(function () {
              if (this.paused) {
                this.play();
              } else {
                this.pause();
              }
            });
            $(this).after('<div class="' + verticalClass + ' video-zoom"><video  class="zoomed-video" src="' + thisSrc + '"></video></div>');
          } else {
            $(this).after('<div class="' + verticalClass + '" style="background-image:url(' + thisSrc + ')"></div>');
          }
        });
        GLOBS.popupSlider = new Swiper("#popup-slider", {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          keyboard: {
            enabled: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          on: {
            slideChangeTransitionStart: function (swiper) {
              if (swiper.realIndex < 2 && $("#popup-slides").hasClass("zoom-active")) {
                $("#popup-slides").parent().parent().removeClass("alt-controls");
              } else {
                if ($(".swiper-slide-active .is-vertical").length > 0) {
                  $("#popup-slides").parent().parent().removeClass("alt-controls");
                } else {
                  if ($("#popup-slides").hasClass("zoom-active")) {
                    $("#popup-slides").parent().parent().addClass("alt-controls");
                  }
                }
              }
              $(".swiper-slide video").each(function (index, value) {
                this.pause();
                this.currentTime = 0;
              });
              $(".swiper-slide.swiper-slide-active video").each(function (index, value) {
                this.play();
              });
            },
            slideChangeTransitionEnd: function (swiper) {
              if (swiper.realIndex < 2 && $("#popup-slides").hasClass("zoom-active")) {
                $("#popup-slides").parent().parent().removeClass("alt-controls");
              } else {
                if ($(".swiper-slide-active .is-vertical").length > 0) {
                  $("#popup-slides").parent().parent().removeClass("alt-controls");
                } else {
                  if ($("#popup-slides").hasClass("zoom-active")) {
                    $("#popup-slides").parent().parent().addClass("alt-controls");
                  }
                }
              }
              $(".swiper-slide video").each(function (index, value) {
                this.pause();
                this.currentTime = 0;
              });
              $(".swiper-slide.swiper-slide-active video").each(function (index, value) {
                this.play();
              });
            },
          },
        });
        $(".zoomed-video").click(function () {
          if (this.paused) {
            console.log("PLAY");
            this.play();
          } else {
            console.log("STOP");
            this.pause();
          }
        });
      });
      $("#project-popup .popup-link").click(function (e) {
        if ($("#popup-slides").hasClass("zoom-active")) {
          $("#popup-slides").removeClass("zoom-active");
          $("#popup-slides").parent().parent().removeClass("alt-controls");
        } else {
          $("#popup-slides").addClass("zoom-active");
          if (GLOBS.popupSlider.realIndex > 1) {
            $("#popup-slides").parent().parent().addClass("alt-controls");
          }
        }
        var text = $(".popup-link").text();
        $(".popup-link").text(text == "Forstørr" ? "Forminsk" : "Forstørr");
      });
      $(".close-popup").click(function (e) {
        closePopup();
      });

      //ESC TO CLOSE
      $(document).keyup(function (e) {
        if (e.key === "Escape") {
          closePopup();
        }
      });
      $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
          // On-page links
          if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
            // Does a scroll target exist?
            if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              $("html, body").animate(
                {
                  scrollTop: target.offset().top - $("#header").outerHeight(),
                },
                1000,
                function () {
                  // Callback after animation
                  // Must change focus!
                  var $target = $(target);
                  if ($target.is(":focus")) {
                    // Checking if the target was focused
                    return false;
                  } else {
                    $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                  }
                }
              );
            }
          }
        });
      $("a[href='#top']").click(function () {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
      });
    };
    //End BIND
    //Inits Functions and Events
    var init = function () {
      bindEvents();
    };
    //END INIT
    //Inits Plugins
    var initPlugins = function () {
      $("#header").headroom();
      /* SWIPER */
      if (document.getElementById("project-slider")) {
        var swiper = new Swiper("#project-slider", {
          slidesPerView: 3,
          spaceBetween: 144,
          speed: 1500,
          freeMode: true,
          loop: true,
          slidesPerView: "auto",
          centeredSlides: true,
          observer: true,
          observeParents: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          breakpoints: {
            0: {
              spaceBetween: 32,
            },
            768: {
              spaceBetween: 144,
            },
          },
        });
      }
      var swiperTemaside = new Swiper(".temaside-project-slider", {
        slidesPerView: 3,
        spaceBetween: 144,
        speed: 1500,
        freeMode: true,
        loop: true,
        slidesPerView: "auto",
        centeredSlides: false,
        observer: true,
        observeParents: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
          0: {
            spaceBetween: 32,
          },
          768: {
            spaceBetween: 144,
          },
        },
      });
      function once(fn, context) {
        var result;
        return function () {
          if (fn) {
            result = fn.apply(context || this, arguments);
            fn = null;
          }
          return result;
        };
      }
      if (document.getElementById("project-slider")) {
        $(window).scroll(function () {
          var element = $("#project-slider");
          var top_of_element = element.offset().top + 100;
          var bottom_of_element = element.offset().top + element.outerHeight();
          var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
          var top_of_screen = $(window).scrollTop();

          if (bottom_of_screen > top_of_element && top_of_screen < bottom_of_element) {
            once(swiper.translateTo(swiper.translate - 280));
            $(window).off("scroll");
          }
        });
      }
      //SWIPER IN LAYOUT
      var layoutSwiper = new Swiper(".layout-slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    };
    //END INIT PLUGINS
    return {
      init: init,
      initPlugins: initPlugins,
    };
  })();
  //## END GENERAL Scripts
  //## Grindaker MAIN
  var GrindakerMain = (function () {
    var init = function () {
      generalScripts.init();
      generalScripts.initPlugins();
    };
    return {
      init: init,
    };
  })();
  //## END Grindaker MAIN
  //Doc Ready
  document.addEventListener(
    "DOMContentLoaded",
    function () {
      GrindakerMain.init();
    },
    false
  );
})((window.Grindaker = window.Grindaker || {}), window.jQuery, window, document);
